import { KeyboardDateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'

import React, { useState, useEffect } from "react";

import 'date-fns';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import MomentUtils from '@date-io/moment'
import './style.scss';
import moment from "moment-timezone"
moment.tz.setDefault('America/New_York');
export const KeyboardDateTimePickerr = ({
    value,
    input,
    label,
    meta: { touched, error },
    config,
    minDate,
    maxDate,
    widthStyle,
    disabled = false,
    onChangeDate,
    defaultValue,
    minTime,
    placeholder,
    maxTime,
    openTo
}) => {
    const [openCalendar, setOpenCalendar] = useState(false);
    const [err, setErr] = useState('')
    widthStyle = widthStyle ? widthStyle : "";
    const validationSpan =
        touched && error ? (
            <span className="error_msg text-danger">{error}</span>
        ) : null;
    const [dateVal, setDateVal] = useState(null)
    const [keywordClass, setKeywordClass] = useState("form-group");
    useEffect(() => {
        setDateVal(defaultValue)
       
    }, [defaultValue])
    useEffect(() => {
        console.log(dateVal, 'defaultValue')
        if (dateVal == '' || dateVal == null) {
            setKeywordClass('form-group')
        } else {
            setKeywordClass('form-group floating-input')

        }
    }, [dateVal])
    return (
      
          
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid>
                <div className={keywordClass}>
                    <KeyboardDateTimePicker
                        className='form-control'
                        {...input}
                        helperText={''}
                        error={false}
                        margin="normal"
                        autoComplete='off'
                        mask={'__/__/____'}
                        id="date-picker-dialog"
                        format='MM/dd/yyyy hh:mm aa'
                        minDate={minDate ? minDate : new Date()}
                        disabled={disabled}
                        value={dateVal}
                        openTo={openTo}
                        allowKeyboardControl={false}
                        placeholder={placeholder}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                        InputProps={{
                            disabled: true,
                            style: { color: 'black' },
                            onClick: () => {
                                !disabled && setOpenCalendar(true)
                            },

                        }}
                        onChange={(value) => {
                            if (onChangeDate) {
                                input.onChange(value);

                                onChangeDate(value)
                                setDateVal(value)
                                setErr('')
                                setOpenCalendar(false)
                            }
                        }}
                        onOpen={() => { setOpenCalendar(true)
                            if (dateVal == '' || dateVal == null) {
                                setKeywordClass('form-group')
                            } else {
                                setKeywordClass('form-group floating-input')
                    
                            }
                        }}
                        onClose={() => { setOpenCalendar(false)    
                            if (dateVal == '' || dateVal == null) {
                                setKeywordClass('form-group')
                            } else {
                                setKeywordClass('form-group floating-input')
                    
                            }}}
                        open={openCalendar}
                    />
                    {validationSpan}
                    {label && <label>{label}</label>}
                    </div>
                </Grid>
         
            </MuiPickersUtilsProvider>
   

    );
};

//className = "form-control"